module.exports = __webpack_public_path__ + "media/images/icons/country_flags/mq-fe327ace5767815c40e373ea37ac9568.svg";